import React, { useState } from 'react';
import { useCart } from '../../contexts/CartContext';
import CartSlideover from './CartSlideover';

function Navbar({ currentPage = 'home' }) {
  const { getTotalItems } = useCart();
  const cartItemCount = getTotalItems();
  const [isCartOpen, setIsCartOpen] = useState(false);

  const toggleCart = (e: React.MouseEvent) => {
    e.preventDefault();
    setIsCartOpen(!isCartOpen);
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark tc-navbar-style1 section-padding-x">
      <div className="container-fluid content">
        <a className="navbar-brand d-flex align-items-center" href="/">
          <img src="/home/assets/img/logo.png" alt="TEMPEFAB" className="logo" />
          <div className="brand-text ms-3">
            <div style={{
              fontSize: '20px',
              fontWeight: 'bold',
              lineHeight: '1.2',
              color: '#fff',
              textTransform: 'uppercase',
              letterSpacing: '1px'
            }}>
              TEMPE FABRICATION
            </div>
            <div style={{
              fontSize: '11px',
              lineHeight: '1.2',
              color: '#fff',
              textTransform: 'uppercase',
              letterSpacing: '0.5px'
            }}>
              Architectural Metalwork
            </div>
          </div>
        </a>

        {/* Cart button - visible on mobile/tablet */}
        <button
          onClick={toggleCart}
          className="cart-button d-lg-none"
          style={{
            position: 'relative',
            marginLeft: 'auto',
            marginRight: '15px',
            color: '#fff',
            fontSize: '40px',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '40px',
            height: '40px',
            padding: 0
          }}
          aria-label="Shopping Cart"
        >
          <i className="la la-shopping-cart"></i>
          {cartItemCount > 0 && (
            <span style={{
              position: 'absolute',
              top: '0',
              right: '0',
              backgroundColor: '#ff5722',
              color: 'white',
              borderRadius: '50%',
              width: '20px',
              height: '20px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '12px',
              fontWeight: 'bold',
              border: '2px solid #000'
            }}>
              {cartItemCount > 99 ? '99+' : cartItemCount}
            </span>
          )}
        </button>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <a className={`nav-link ${currentPage === 'home' ? 'active' : ''}`} aria-current={currentPage === 'home' ? 'page' : undefined} href="/">
                HOME
              </a>
            </li>
            <li className="nav-item">
              <a className={`nav-link ${currentPage === 'portfolio' ? 'active' : ''}`} aria-current={currentPage === 'portfolio' ? 'page' : undefined} href="/portfolio">
                PORTFOLIO
              </a>
            </li>
            <li className="nav-item">
              <a className={`nav-link ${currentPage === 'about' ? 'active' : ''}`} aria-current={currentPage === 'about' ? 'page' : undefined} href="/about">
                ABOUT
              </a>
            </li>
            {/* PRODUCTS tab temporarily hidden - uncomment to re-enable
            <li className="nav-item">
              <a className={`nav-link ${currentPage === 'products' ? 'active' : ''}`} aria-current={currentPage === 'products' ? 'page' : undefined} href="/products">
                PRODUCTS
              </a>
            </li>
            */}
            <li className="nav-item">
              <a className={`nav-link ${currentPage === 'contact' ? 'active' : ''}`} aria-current={currentPage === 'contact' ? 'page' : undefined} href="/contact">
                CONTACT
              </a>
            </li>
          </ul>
          <div className="nav-side d-flex align-items-center">
            {/* Cart button for desktop */}
            <button
              onClick={toggleCart}
              className="cart-button d-none d-lg-flex"
              style={{
                position: 'relative',
                color: '#fff',
                fontSize: '40px',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '40px',
                height: '40px',
                marginRight: '10px',
                padding: 0
              }}
              aria-label="Shopping Cart"
            >
              <i className="la la-shopping-cart"></i>
              {cartItemCount > 0 && (
                <span style={{
                  position: 'absolute',
                  top: '-5px',
                  right: '-5px',
                  backgroundColor: '#ff5722',
                  color: 'white',
                  borderRadius: '50%',
                  width: '20px',
                  height: '20px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '12px',
                  fontWeight: 'bold',
                  border: '2px solid #000'
                }}>
                  {cartItemCount > 99 ? '99+' : cartItemCount}
                </span>
              )}
            </button>
            <a href="#" className="icon ms-3 side_menu_btn fsz-21">
              <span>
                <i className="la la-grip-lines"></i>{' '}
              </span>
            </a>
          </div>
        </div>
      </div>

      {/* Cart Slideover */}
      <CartSlideover isOpen={isCartOpen} onClose={() => setIsCartOpen(false)} />
    </nav>
  );
}

export default Navbar;